export const normalizePhone = (raw) => {
  if (!raw) return null;
  let p = String(raw).trim().replace(/[^\d+]/g, '');
  if (!p) return null;
  if (p.startsWith('00')) p = `+${p.slice(2)}`;
  if (p.startsWith('05') && p.length === 10) p = `+966${p.slice(1)}`;
  else if (p.startsWith('5') && p.length === 9) p = `+966${p}`;
  if (!p.startsWith('+')) p = `+${p}`;
  return p;
};

export const whatsappLink = (raw) => {
  const p = normalizePhone(raw);
  return p ? `https://wa.me/${p.replace('+', '')}` : null;
};

export const copyToClipboard = async (text) => {
  try { await navigator.clipboard.writeText(text); return true; } catch { return false; }
};
